const flaskServer = {
  flaskServerIP: '/api',
  flaskServerIPRoot: '',
};

export default flaskServer;